// components/GlobalFloating.tsx
'use client';

import { useState } from 'react';
import FloatingContact from './FloatingContact';
import FloatingAIBuilder from './FloatingAIBuilder';
import AIBuilderPanel from './AIBuilderPanel';

export default function GlobalFloating() {
    const [isAIOpen, setIsAIOpen] = useState(false);

    return (
        <>
            {/* Left Side: WhatsApp + Call */}
            <FloatingContact />

            {/* Right Side: AI Builder Toggle */}
            <FloatingAIBuilder
                onOpen={() => setIsAIOpen(true)}
                isOpen={isAIOpen}
            />

            {/* AI Builder Panel/Drawer */}
            <AIBuilderPanel
                isOpen={isAIOpen}
                onClose={() => setIsAIOpen(false)}
            />
        </>
    );
}